import { useContext } from 'react';
import { ThemesFiltersContext } from 'providers/ThemesFilters';

const useThemesFilters = () => useContext(ThemesFiltersContext);

export default useThemesFilters;
